import React, { Fragment, useEffect } from "react";
import { FormContainer } from "../../parts/form-container/FormContainer";
import successIcon from "../../assets/images/icon-success-lg.svg";

export const RegistrationComplete = () => {
  const PAGE_NAME = "registrationcomplete";

  useEffect(() => {
    document.title = "Registration Complete | Simplyhealth";
  }, []);

  return (
    <FormContainer
      pageName={PAGE_NAME}
      title="Registration Complete"
      messages={["Thank you for registering your Simplyhealth account.", "You can now close this page and log into the app."]}
      image={<img src={successIcon} alt="Success" />}
      fields={<Fragment />}
      action={<Fragment />}
    />
  );
};
